import React from "react";
import { Box, Skeleton, Card, Tabs, Tab, useTheme } from "@mui/material";

const ProfileTabsShimmer = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <Tabs value={0} variant="fullWidth" sx={{ mb: 3 }}>
        <Tab label={<Skeleton width="80%" height={24} />} />
        <Tab label={<Skeleton width="80%" height={24} />} />
      </Tabs>

      <Box sx={{ pt: 2 }}>
        {[...Array(5)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={56}
            sx={{ mb: 2 }}
          />
        ))}
      </Box>
    </Card>
  );
};

export default ProfileTabsShimmer;